<script setup lang="ts">
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import OrderGroupSelectInput from './OrderGroupSelectInput.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';

const t = i18n.t;
const props = defineProps<{
  isOpening: boolean;
  title: string;
  description: string;
  nextButtonLabel: string;
  backButtonLabel?: string;
}>();
const emits = defineEmits<{ (e: 'next'): void; (e: 'back'): void }>();

// i18n.tがwithDefault内で使えないのでこうしている
const withDefaultBackButtonLabel = computed(() => props.backButtonLabel ?? t('キャンセル'));
</script>
<template>
  <InfoModal
    :modal-state="isOpening"
    :next-button-label="nextButtonLabel"
    :back-button-label="withDefaultBackButtonLabel"
    enable-outside-click
    :modal-width="764"
    @on-next="emits('next')"
    @on-back="emits('back')"
  >
    <template #title>
      {{ title }}
    </template>
    <template #description>
      {{ description }}
    </template>
    <template #default>
      <div class="order-group-select-modal-content">
        <OrderGroupSelectInput />
      </div>
    </template>
  </InfoModal>
</template>
<style lang="scss" scoped>
.order-group-select-modal-content {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
}
</style>
